import Api from 'utils/api.js'
// https://django-rest-auth.readthedocs.io/en/latest/api_endpoints.html

// fetch user data if authenticated or errors with status 403
export const currentUser = () => Api.get('rest-auth/user')

// set user language
export const changeActiveLanguage = ({ language }) =>
  Api.patch('rest-auth/user', { language })

// set user account
export const changeActiveAccount = ({ account_id }) =>
  Api.patch('rest-auth/user', { active_account: account_id })

// login user and set session cookie
export const logIn = ({ email, password }) =>
  Api.post('rest-auth/login', { email, password })

// logout user (invalidates cookies)
export const logOut = () => Api.post('rest-auth/logout')

// request reset password link
export const passwordResetRequest = ({ email }) =>
  Api.post('rest-auth/password/reset', { email })

// register new account
export const registerAccount = data => Api.post('rest-auth/registration', data)

// reset password
// `uid` and `token` are sent in email after calling /rest-auth/password/reset/
export const passwordResetConfirm = ({ uid, token, password }) =>
  Api.post('rest-auth/password/reset/confirm', {
    uid,
    token,
    new_password1: password,
    new_password2: password,
  })

// change password
export const passwordChange = ({ newPassword, oldPassword }) =>
  Api.post('rest-auth/password/change', {
    new_password1: newPassword,
    new_password2: newPassword,
    old_password: oldPassword,
  })
